import { z } from "zod";
import superjson from "superjson";
import type { Selectable } from "kysely";
import type {
  Organizations,
  Properties,
  Tenants,
  Units,
} from "../../helpers/schema";

export const schema = z.object({});

export type OutputType = {
  profiles: Array<{
    tenantId: Selectable<Tenants>["id"];
    name: Selectable<Tenants>["name"];
    companyName: Selectable<Tenants>["companyName"];
    organizationName: Selectable<Organizations>["name"] | null;
    propertyName: Selectable<Properties>["name"] | null;
    unitNumber: Selectable<Units>["unitNumber"] | null;
  }>;
  activeTenantId: Selectable<Tenants>["id"] | null;
  selectionRequired: boolean;
};

export const getMyProfiles = async (
  body: z.infer<typeof schema> = {},
  init?: RequestInit
): Promise<OutputType> => {
  schema.parse(body);

  const result = await fetch("/_api/tenant-portal/my-profiles", {
    ...init,
    method: "GET",
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(
      await result.text()
    );
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};